import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from '../components/Button';
import Modal from '../components/Modal';
import { RxCross1 } from "react-icons/rx";
import { Carousel } from 'react-responsive-carousel';
import './PackageInfo.css';
import Services from '../services/Services';
import { CircularProgress } from '@mui/material';
import { getOrCreateSessionID } from '../utils/sessionManager';
import { logEvent } from '../utils/analyticsManager'; // GA4 Import

import 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function PackageInfo() {
    const { token, campaignID, companyID } = useParams();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [campaign, setCampaign] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [agreements, setAgreements] = useState([]);
    const [poiID, setPoiID] = useState('');

    const [couponLoading, setCouponLoading] = useState(false);
    const [couponError, setCouponError] = useState("");
    const [couponData, setCouponData] = useState(null);
    const [couponModalOpen, setCouponModalOpen] = useState(false);
    const [campaignHasCoupon, setCampaignHasCoupon] = useState(null);
    const [campaignHadCoupon, setCampaignHadCoupon] = useState(null);

    // Yeni durumlar: şartları kabul etme
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [currentAgreementIndex, setCurrentAgreementIndex] = useState(0);

    // SessionID için state
    const [sessionID, setSessionID] = useState(null);

    useEffect(() => {
        // SessionID'yi al
        const sid = getOrCreateSessionID();
        setSessionID(sid);

        Services.BolParaAboutToken(token)
            .then((res) => {
                if (res?.data?.status) {
                    setPoiID(res.data.result?.easypointID || '');
                } else {
                    setPoiID('');
                }
            })
            .catch(() => setPoiID(''));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCampaign = () => {
        Services.GetBolParaCampaign(token, campaignID)
            .then((res) => {
                if (res.data.status) {
                    setCampaign(res.data.result);
                    getCampaignAgreements();
                } else {
                    setCampaign();
                    setIsLoading(false);
                }
            })
            .catch((err) => console.log(err));
    };

    const getCampaignAgreements = () => {
        Services.GetBolParaAgreement(token, campaignID)
            .then((res) => {
                if (res.data.status) {
                    setAgreements(res.data.result);
                    console.log(res.data.result);
                } else {
                    setAgreements([]);
                }
                setIsLoading(false);
            })
            .catch((err) => console.log(err));
    };

    const checkThisCampaignHasCoupon = () => {
        setCampaignHasCoupon(null);
        setCampaignHadCoupon(null);
        Services.GetBolParaCampaignHasCoupon(token, campaignID)
            .then((res) => {
                const ok = res?.data?.status === true;
                if (!ok) {
                    setCampaignHasCoupon(false);
                    setCampaignHadCoupon(false);
                    return;
                }
                const result = res?.data?.result;
                if (result && typeof result === "object") {
                    setCampaignHasCoupon(Boolean(result.hasCoupon));
                    setCampaignHadCoupon(Boolean(result.hadCoupon));
                } else {
                    setCampaignHasCoupon(true);
                    setCampaignHadCoupon(true);
                }
            })
            .catch(() => {
                setCampaignHasCoupon(false);
                setCampaignHadCoupon(false);
            });
    };

    useEffect(() => {
        checkThisCampaignHasCoupon();
        getCampaign();
    }, []);

    const formattedTitles = agreements.length > 0 ? (
        agreements.length === 1 ? agreements[0].title :
            agreements.length === 2 ? `${agreements[0].title} ve ${agreements[1].title}` :
                agreements.slice(0, -2).map(item => item.title).join(", ") + ", " +
                `${agreements[agreements.length - 2].title} ve ${agreements[agreements.length - 1].title}`
    ) : "";

    const shouldShowCouponInsteadOfQR = useMemo(() => {
        if (!campaign) return false;
        if (campaign?.hasForm === "1") return false;
        const isDepleted = campaignHadCoupon === true && campaignHasCoupon === false;
        if (campaignHasCoupon === null) return false;
        return !isDepleted && campaignHasCoupon === true;
    }, [campaign, campaignHasCoupon, campaignHadCoupon]);

    const handleGetCampaignCoupon = () => {
        setCouponError('');
        setCouponLoading(true);
        setCouponData(null);

        if (!poiID) {
            setCouponError('POI bilgisi alınamadı. Lütfen sayfayı yenileyip tekrar deneyin.');
            setCouponModalOpen(true);
            setCouponLoading(false);
            return;
        }
        Services.GetNewCampaignCoupon(token, companyID, campaignID, poiID)
            .then((r) => {
                if (r?.data?.status) {
                    setCouponData(r.data.result || r.data);
                    setCouponModalOpen(true);
                    checkThisCampaignHasCoupon();
                } else {
                    setCouponError('Kupon alınamadı. Lütfen tekrar deneyin.');
                    setCouponModalOpen(true);
                }
            })
            .catch(() => {
                setCouponError('Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.');
                setCouponModalOpen(true);
            })
            .finally(() => setCouponLoading(false));
    };

    const handleQRCodeView = () => {
        // GA4: QR Kodu Görüntüleme
        if (campaign) {
             logEvent('Conversion', 'QR Kod Görüntülendi', campaign.title);
        }

        // Mevcut Backend Tracking
        if (sessionID && campaign) {
            Services.AddAnalyticsTracking(
                token,
                sessionID,
                'qr_code_view',
                campaign.title,
                'click'
            ).catch((err) => console.log('Analytics tracking error:', err));
        }

        setIsModalOpen(true);
    }

    console.log(campaign)
    const renderCouponContent = () => {
        if (couponLoading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
                    <CircularProgress />
                </div>
            );
        }
        if (couponError) {
            return <p style={{ color: '#e11d48', fontSize: 14 }}>{couponError}</p>;
        }
        if (!couponData) {
            return <p style={{ color: '#64748B', fontSize: 12 }}>Gösterilecek kupon bulunamadı.</p>;
        }
        const code = couponData.code || couponData.couponCode || couponData.CouponCode;
        const title = couponData.title || campaign?.title || "Kupon";
        const description = couponData.description || couponData.desc;
        const expireDate = couponData.expireDate || couponData.expiration || couponData.validUntil;
        const qrUrl = couponData.qrUrl || couponData.qrCodeUrl || couponData.qr;
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <h3 style={{ margin: 0 }}>{title}</h3>
                {description && <p style={{ color: '#475569', margin: 0 }}>{description}</p>}
                {code && (
                    <>
                        <div style={{
                            background: '#f1f5f9',
                            border: '1px dashed #94a3b8',
                            padding: '12px 16px',
                            borderRadius: 8,
                            fontWeight: 700,
                            letterSpacing: 1.2,
                            textAlign: 'center'
                        }}>
                            {code}

                        </div>
                        {campaign.title === "İndirim Kodu" &&
                            <p>
                                Avon.com.tr üzerinden yapılan 600 TL  ve üzeri alışverişlerde geçerlidir. İndirim Kodları tek kullanımlıktır.
                            </p>
                        }
                    </>
                )}
                {expireDate && (
                    <p style={{ color: '#64748B', fontSize: 12, margin: 0 }}>
                        Son Kullanım: {expireDate}
                    </p>
                )}
                {qrUrl && (
                    <img
                        src={qrUrl}
                        alt="Kupon QR Kodu"
                        style={{ alignSelf: 'center', maxWidth: 220, height: 'auto' }}
                    />
                )}
                {!code && !description && !qrUrl && (
                    <pre style={{
                        background: '#0f172a',
                        color: '#e2e8f0',
                        padding: 12,
                        borderRadius: 8,
                        maxHeight: 300,
                        overflow: 'auto'
                    }}>
                        {JSON.stringify(couponData, null, 2)}
                    </pre>
                )}
            </div>
        );
    };
    return (
        <body>
            <div className='main' style={{ width: '100%' }}>
                {isLoading ? (
                    <div style={{ marginTop: '35%' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        {campaign && (
                            <>
                                {campaign.images && (
                                    <Carousel
                                        showStatus={false}
                                        showArrows={false}
                                        autoPlay={true}
                                        interval={3000}
                                        infiniteLoop={true}
                                        showThumbs={false}
                                        showIndicators={false}
                                        className="custom-carousel">
                                        {campaign.images.map((image, index) => (
                                            <div key={index} className="carousel-image-container">
                                                <img src={image} alt={`Image ${index}`} className="carousel-image" />
                                            </div>
                                        ))}
                                    </Carousel>
                                )}

                                {/* Checkbox ve agreement başlıkları */}
                                {agreements.length > 0 &&
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '50px', marginBottom: '10px', width: '90%' }}>
                                        <input
                                            type="checkbox"
                                            className="custom-checkbox"
                                            checked={termsAccepted}
                                            onClick={() => {
                                                if (!termsAccepted) {
                                                    setIsTermsModalOpen(true);
                                                    setCurrentAgreementIndex(0);
                                                } else {
                                                    setTermsAccepted(false);
                                                    setCurrentAgreementIndex(0);
                                                }
                                            }}
                                        />

                                        <label style={{ marginLeft: '8px' }}>{formattedTitles}</label>
                                    </div>
                                }


                                {shouldShowCouponInsteadOfQR ? (
                                    <Button
                                        onClick={handleGetCampaignCoupon}
                                        style={{ marginTop: '5%', width: '236px' }}
                                        variant={'primary'}
                                        label={couponLoading ? 'Kod alınıyor...' : 'İndirim Kodu Ver'}
                                        disabled={(agreements.length > 0 && !termsAccepted) || couponLoading}
                                    />
                                ) : (
                                    <Button
                                        onClick={handleQRCodeView}
                                        style={{ marginTop: '5%', width: '236px' }}
                                        variant={'primary'}
                                        label={'QR Kodu Görüntüle'}
                                        disabled={!termsAccepted && agreements.length > 0}
                                    />
                                )}

                                <div style={{ padding: '20px' }}>
                                    <div style={{ alignSelf: 'flex-start', marginBottom: '50%' }}>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: campaign.description }}
                                            style={{ whiteSpace: 'pre-wrap' }}
                                        />
                                    </div>
                                </div>

                                {/* QR Kodu gösteren modal */}
                                <Modal visible={isModalOpen} style={{
                                    height: '350px', width: '350px', position: 'fixed', top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)'
                                }}>
                                    <div style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '15px',
                                        alignItems: 'center',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        <div style={{
                                            width: '100%',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end',
                                            display: 'flex'
                                        }}>
                                            <RxCross1 onClick={() => setIsModalOpen(false)} />
                                        </div>
                                        <div style={{
                                            backgroundColor: 'black',
                                            marginTop: '10px',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            display: 'flex',
                                            width: '169px',
                                            height: '169px',
                                            borderRadius: '8px'
                                        }}>
                                            <img
                                                style={{ width: '147px' }}
                                                src={`https://qr.easypointapi.com/?chl=https://bolpara.easypoint.com.tr?token=${token}:${campaignID}`}
                                                alt='QR Code'
                                            />
                                        </div>
                                        <a
                                            style={{
                                                fontWeight: '400',
                                                fontSize: '14px',
                                                marginTop: '14px'
                                            }}
                                            href={`https://bolpara.easypoint.com.tr?token=${token}:${campaignID}`}>
                                            Forma gitmek için tıklayın
                                        </a>
                                        <text style={{
                                            color: '#64748B',
                                            fontWeight: '400',
                                            fontSize: '12px',
                                            marginTop: '14px'
                                        }}>ya da</text>
                                        <text style={{
                                            color: '#64748B',
                                            fontWeight: '400',
                                            fontSize: '12px',
                                            marginTop: '14px'
                                        }}>QR Kodu</text>
                                        <text style={{
                                            color: '#64748B',
                                            fontWeight: '400',
                                            fontSize: '11px',
                                            marginTop: '8px',
                                            textAlign: 'center'
                                        }}>
                                            Müşterinizin başvuru formuna ulaşması için QR Kodu okutmasını isteyiniz.
                                        </text>
                                    </div>
                                </Modal>

                                {isTermsModalOpen && (
                                    <Modal visible={isTermsModalOpen} style={{ width: '290px', padding: '25px', marginTop: '55%' }}>
                                        <div style={{
                                            width: '100%',
                                            padding: '15px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center'
                                        }}>
                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-end'
                                            }}>
                                                <RxCross1 onClick={() => {
                                                    setIsTermsModalOpen(false);
                                                    setCurrentAgreementIndex(0);
                                                }} />
                                            </div>
                                            <div style={{
                                                flex: 1,
                                                marginTop: '10px',
                                                overflowY: 'auto',
                                                width: '100%'
                                            }}>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: agreements[currentAgreementIndex]?.content }}
                                                    style={{ whiteSpace: 'pre-wrap' }}
                                                />
                                            </div>
                                            <Button
                                                onClick={() => {
                                                    if (currentAgreementIndex < agreements.length - 1) {
                                                        setCurrentAgreementIndex(currentAgreementIndex + 1);
                                                    } else {
                                                        // Son agreement kabul edildiğinde modal kapatılır ve checkbox true olur
                                                        setTermsAccepted(true);
                                                        setIsTermsModalOpen(false);
                                                    }
                                                }}
                                                style={{ marginTop: '10px', width: '100%' }}
                                                variant={'primary'}
                                                label={'Koşulları Kabul Ediyorum'}
                                            />
                                        </div>
                                    </Modal>
                                )}

                                {couponModalOpen && (
                                    <Modal visible={couponModalOpen} style={{ width: '320px', padding: '20px', marginTop: '55%' }}>
                                        <div style={{
                                            width: '100%',
                                            padding: '10px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 10
                                        }}>
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                                <RxCross1 onClick={() => setCouponModalOpen(false)} />
                                            </div>
                                            <div style={{ width: '100%' }}>
                                                {renderCouponContent()}
                                            </div>
                                        </div>
                                    </Modal>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </body>
    );
}